const styles = () => ({
  container: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: `rgba(255,255,255,0.7)`,
    zIndex: 1000,
  },
});

export default styles;
